import { render, staticRenderFns } from "./aed-adminChange.vue?vue&type=template&id=42123af6&"
import script from "./aed-adminChange.vue?vue&type=script&lang=js&"
export * from "./aed-adminChange.vue?vue&type=script&lang=js&"
import style0 from "./aed-adminChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports